import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 10px;
  /* text-align: center; */
  /* justify-content: space-between; */
`;

export const SidebarBtn = styled.div`
  padding: 10px;
`;
